<script setup lang="ts">
defineProps<{
  rows: number
}>()
</script>

<template>
  <div class="flex-fill">
    <div v-for="row in rows" :key="row" class="py-3 my-3 loading"></div>
  </div>
</template>
